import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "notification is-danger is-light"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " Une erreur inattendue est survenue pendant le chargement des dernières opérations de votre compte. Veuillez nous excuser pour le désagrément. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Vous pouvez essayer de recharger la page, ou contacter votre administrateur si l'erreur persiste. ", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "notification is-default"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "custom-card-title" }, "Opérations", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_TransactionSubCard = _resolveComponent("TransactionSubCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, {
      active: _ctx.isLoadingTransactions,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoadingTransactions) = $event)),
      "can-cancel": false,
      "is-full-page": false
    }, null, 8, ["active"]),
    (!_ctx.isLoadingTransactions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.hasTransactionsLoadingError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
            : (_ctx.getTrs?.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Aucune opération dans votre historique "))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTrs, (transaction) => {
                    return (_openBlock(), _createBlock(_component_TransactionSubCard, {
                      key: transaction,
                      amount: transaction.amount,
                      symbol: transaction.currency,
                      desc: transaction.description,
                      date: _ctx.dateFormated(transaction.date),
                      unformatedDate: transaction.date,
                      name: 
          transaction.relatedUser
            ? transaction.relatedUser.display
            : transaction.related.type.name
        ,
                      picto: "QR"
                    }, null, 8, ["amount", "symbol", "desc", "date", "unformatedDate", "name"]))
                  }), 128))
                ]))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}